import React from "react";
import "./Banner.css"

function Banner () {
    return (
        <img src={require("../../images/Castle-Banner.png")} alt="Banner" className="banner"></img>
    )
}

export default Banner;